import svg from '!!raw-loader!!../assets/delete-button-icon.svg'; // eslint-disable-line
import { styled } from 'css-literal-loader/styled';
import React from 'react';
import BaseModal from 'react-overlays/Modal';
import withProps from 'recompose/withProps';

import Card from './Card';

const Background = styled('div', null, "Background", require("./Modal-Background.module.scss"), "background", "background");

const CloseButton = withProps({ dangerouslySetInnerHTML: { __html: svg } })(
  styled('button', null, "CloseButton", require("./Modal-CloseButton.module.scss"), "close-button", "closeButton"),
);

const StyledBaseModal = styled(BaseModal, null, "StyledBaseModal", require("./Modal-StyledBaseModal.module.scss"), "styled-base-modal", "styledBaseModal");

const Dialog = styled(Card, null, "Dialog", require("./Modal-Dialog.module.scss"), "dialog", "dialog");

const ModalBody = withProps({ grow: true })(
  styled(Card.Body, null, "ModalBody", require("./Modal-ModalBody.module.scss"), "modal-body", "modalBody"),
);

const ModalImage = styled('img', null, "ModalImage", require("./Modal-ModalImage.module.scss"), "modal-image", "modalImage");

const propTypes = {};

class Modal extends React.Component {
  handleClick = e => {
    if (e.target !== e.currentTarget) return;

    this.props.onHide();
  };

  renderBackdrop = props => <Background {...props} />;

  render() {
    const {
      children,
      show,
      onHide,
      closeButton,
      className,
      center,
      fullHeight,
    } = this.props;

    return (
      <StyledBaseModal
        show={show}
        onHide={onHide}
        onClick={this.handleClick}
        renderBackdrop={this.renderBackdrop}
      >
        <Dialog className={className} fill={fullHeight} center={center}>
          {closeButton && <CloseButton onClick={onHide} />}
          {children}
        </Dialog>
      </StyledBaseModal>
    );
  }
}

Modal.propTypes = propTypes;
Modal.Body = ModalBody;
Modal.Image = ModalImage;

export default Modal;
